import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglescholarComponent } from './simple-icons-googlescholar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglescholarComponent ],
    exports:      [ SimpleIconsGooglescholarComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglescholarModule {}
